import React from 'react'
import { withTranslation } from 'react-i18next'
import SignRequestByVolumeAdditionalServicesView from '../../views/sign-request-by-volume-additional-services/sign-request-by-volume-additional-services.view'
import SignRequestByVolumeDescriptionView from '../../views/sign-request-by-volume-description/sign-request-by-volume-description.view'
import SignRequestByVolumeSignersListView from '../../views/sign-request-by-volume-signers-list/sign-request-by-volume-signers-list.view'
import SignRequestByVolumeUploadFilesView from '../../views/sign-request-by-volume-upload-files/sign-request-by-volume-upload-files.view'
import SignRequestByVolumeResume from '../../views/sign-request-by-volume-resume/sign-request-by-volume-resume.view'
import SignRequestByVolumeView from '../../views/sign-request-by-volume/sign-request-by-volume.view'
import { SimpleLoading, ValidateInputPure } from '../../pures'
import { NIL as NIL_UUID } from 'uuid'
import SignRequestByVolumeValidator from '../../../validators/sign-request-by-volume.validator'
import {
  SignatureProfileService,
  LocalStorageService,
  SignatureRequestService,
  SignerTypeService,
  ProcessTypeService,
  SignatureTypesService,
  UserService,
  ServiceService,
  DomainService
} from '../../../services'
import initialState from '../../../utils/initialState'
import {
  SignRequestByVolumeStepOneIcon,
  SignRequestByVolumeStepTwoIcon,
  SignRequestByVolumeStepThreeIcon,
  SignRequestByVolumeStepFourIcon,
  SignRequestByVolumeStepFiveIcon,
} from '../../../assets/logos/icons'
import { extractEmailDomain } from '../../../utils'

class SignRequestByVolumeAction extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedStep: 0,
      loading: false,
      validators: [],
      requestName: '',
      comments: '',
      description: '',
      errorCurrentComments: false,
      errorCurrentDescription: false,
      token: '',
      csvJson: [],
      signatureTypesInputValue: [],
      errorSignatureTypeId: false,
      processTypesInputValue: [],
      errorProcessTypeId: false,
      services: [],
      servicesInputValue: [],
      selectedFiles: [],
      errorFiles: false,
      signerTypes: [],
      processTypes: [],
      timezone: null,
      signatureRequests: [],
      loadingContractsSignatures: true,
      signatureTypes: [],
      collaboratorListAllow: [],
      inviteListAllow: [],
      usersCollaborator: [],
      usersInvites: [],
      limitDate: '',
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      disableSignerButton: true,
      message: '',

      serviceSTWillShow: false,
      serviceSTChecked: false,
      serviceSTCanModify: true,

      serviceCMWillShow: false,
      serviceCMChecked: false,
      serviceCMCanModify: true,

      signatureTypeESignWillShow: false,
      signatureTypeESignChecked: false,
      signatureTypeESignCanModify: true,

      signatureTypeAdvancedWillShow: false,
      signatureTypeAdvancedChecked: false,
      signatureTypeAdvancedCanModify: true,

      signatureTypeAutographWillShow: false,
      signatureTypeAutographChecked: false,
      signatureTypeAutographCanModify: true,

      processTypeRandomWillShow: false,
      processTypeRandomChecked: false,
      processTypeRandomCanModify: true,

      processTypeSequentialWillShow: false,
      processTypeSequentialChecked: false,
      processTypeSequentialCanModify: true,

      processTypeAprovationlWillShow: false,
      processTypeAprovationChecked: false,
      processTypeAprovationCanModify: true,

      processTypeAprovationSequentialWillShow: false,
      processTypeAprovationSequentialChecked: false,
      processTypeAprovationSequentialCanModify: true,

      servicesId: [],
      serviceId: '',
      signatureTypeId: '',
      servicesCheck: '',
      servicesCheckTwo: '',
      signatureTypeCheck: '',
      signatureTypeCheckTwo: '',
      signatureTypeCheckThree: '',
      processTypeId: '',
      processTypeName: '',

      signatureByVolumeProfile: {},
      csvJsonAsText: '',
      errorCurrentNameSignature: false,
      errorMessageCurrentNameSignature: '',
      errorMessageCurrentDescription: '',
      errorMessageCurrentComments: '',
      signtureRequestProfile: Number(process.env.REACT_APP_CODE_SIGNATURE_PROFILE_SIGNATURES_BY_VOLUME),
      loading: false,
      domains: []
    }
  }

  toke = {}
  url = process.env.REACT_APP_MIFIRMA_API
  signatureProfileService = new SignatureProfileService(this.url)
  localStorageService = new LocalStorageService()
  signatureRequestService = new SignatureRequestService(this.url)
  signerTypeService = new SignerTypeService(this.url)
  processTypeService = new ProcessTypeService(this.url)
  signatureTypesService = new SignatureTypesService(this.url)
  UserService = new UserService(this.url)
  serviceService = new ServiceService(this.url)
  domainService = new DomainService(this.url)

  validator = SignRequestByVolumeValidator(this.props.t)

  async componentDidMount() {
    this.setState({ loading: true })
    this.token = this.localStorageService.getLocalStorageItem('token').idToken
    this.user = this.localStorageService.getLocalStorageItem('user')
    let requestForProfileByVolume =
      await this.signatureProfileService.getSignatureProfilesById(
        this.token,
        2
      )

    try {
      this.setState({
        token: this.token,
        signatureByVolumeProfile: requestForProfileByVolume.data,
      })
    } catch (error) {
      this.props.history.push('/')
      this.props.setShowError(true)
      return
    }

    let signerTypes = initialState['signerTypeService.getSignerTypes']
    if (!signerTypes) {
      signerTypes = await this.signerTypeService.getSignerTypes(this.token)
      initialState['signerTypeService.getSignerTypes'] = signerTypes
    }

    let processTypes = initialState['processTypeService.getProcessTypes']
    if (!processTypes) {
      processTypes = await this.processTypeService.getProcessTypes(this.token)
      initialState['processTypeService.getProcessTypes'] = processTypes
    }

    let signatureTypes =
      initialState['signatureTypesService.getSignatureTypes']
    if (!signatureTypes) {
      signatureTypes = await this.signatureTypesService.getSignatureTypes(
        this.token
      )
      initialState['signatureTypesService.getSignatureTypes'] = signatureTypes
    }

    let navegatorTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone
    let timezone = `${navegatorTimezone}`

    // get users collaborator
    let usersCollaborator = []
    let usersInvites = []
    let collaboratorsActive = []
    let invitesActive = []
    const email = null
    const collaborators = true
    const invites = true
    const offset = 0
    const limit = Number(process.env.REACT_APP_OFFSET_LIMIT_COLLABORATOR_VOLUMEN)
    const usersCollaboratorBD = await this.UserService.getUsersCollaboratorsOrInvites(this.token, collaborators, invites, offset, limit, email)
    if (usersCollaboratorBD) {
      usersCollaborator = usersCollaboratorBD.usersCollaborator.active && usersCollaboratorBD.usersCollaborator.inactive ? usersCollaboratorBD.usersCollaborator.active.concat(usersCollaboratorBD.usersCollaborator.inactive) : []
      usersInvites = usersCollaboratorBD.usersInvite.active && usersCollaboratorBD.usersInvite.inactive ? usersCollaboratorBD.usersInvite.active.concat(usersCollaboratorBD.usersInvite.inactive) : []
      collaboratorsActive = (usersCollaboratorBD.usersCollaborator && usersCollaboratorBD.usersCollaborator.active) ? usersCollaboratorBD.usersCollaborator.active : []
      invitesActive = (usersCollaboratorBD.usersInvite && usersCollaboratorBD.usersInvite.active) ? usersCollaboratorBD.usersInvite.active : []
    }

    const domainsRequest = await this.domainService.getDomains(this.token)
    let domains = []
    for (const domain of domainsRequest) {
      domains.push(domain.name.toLowerCase())
    }

    try {
      this.setState({
        signerTypes,
        processTypes,
        signatureTypes,
        timezone,
        // signatureRequests: requests2.data,
        loadingContractsSignatures: true,
        token: this.token,
        url: this.url,
        collaboratorListAllow: collaboratorsActive,
        inviteListAllow: invitesActive,
        usersCollaborator,
        usersInvites,
        domains
      })
    } catch (error) {
      this.props.history.push('/')
      this.props.setShowError(true)
      return
    }

    const {
      serviceTimeStamp,
      serviceConservationMessage,
      signatureTypeESign,
      signatureTypeAdvance,
      signatureTypeAutograph,
      processRandom,
      processSequential,
      processAprovation,
      processAprovationSequential,
    } = this.state.signatureByVolumeProfile

    /* === Validating services PSC Checkboxes === */
    /* 1.- Service ST (Stamp Time) || 2.- Service CM (Conservation Message) */
    if (serviceTimeStamp) {
      this.setState({
        serviceSTWillShow: true,
        serviceSTChecked: true,
        serviceSTCanModify: false,
        servicesId: this.state.servicesId.concat(1),
      })
    }

    if (serviceConservationMessage) {
      this.setState({
        serviceCMWillShow: true,
        serviceCMChecked: true,
        serviceCMCanModify: false,
        servicesId: this.state.servicesId.concat(2),
      })
    }

    if (serviceTimeStamp === false && serviceConservationMessage === false) {
      this.setState({
        serviceSTWillShow: true,
        serviceCMWillShow: true,
        serviceSTChecked: false,
        serviceCMChecked: false,
      })
    }

    /* === Validating Signature Types Checkboxes === */
    /* 1.- ESign || 2.- Advanced || 3.- Autograph */
    let arraySignatureTypes = [
      { id: 1, active: signatureTypeESign },
      { id: 2, active: signatureTypeAdvance },
      { id: 3, active: signatureTypeAutograph },
    ]

    for (let i = 0; i < arraySignatureTypes.length; i++) {
      // eslint-disable-next-line default-case
      switch (arraySignatureTypes[i].id) {
        case 1:
          if (arraySignatureTypes[i].active === true) {
            this.setState({ signatureTypeESignWillShow: true })
          }
          if (
            signatureTypeESign === true &&
            signatureTypeAdvance === false &&
            signatureTypeAutograph === false
          ) {
            this.setState({
              signatureTypeESignChecked: true,
              signatureTypeESignCanModify: false,
              signatureTypeId: 1,
            })
          }
          break
        case 2:
          if (arraySignatureTypes[i].active === true) {
            this.setState({ signatureTypeAdvancedWillShow: true })
          }
          if (
            signatureTypeESign === false &&
            signatureTypeAdvance === true &&
            signatureTypeAutograph === false
          ) {
            this.setState({
              signatureTypeAdvancedChecked: true,
              signatureTypeAdvancedCanModify: false,
              signatureTypeId: 2,
            })
          }
          break
        case 3:
          if (arraySignatureTypes[i].active === true) {
            this.setState({ signatureTypeAutographWillShow: true })
          }
          if (
            signatureTypeESign === false &&
            signatureTypeAdvance === false &&
            signatureTypeAutograph === true
          ) {
            this.setState({
              signatureTypeAutographChecked: true,
              signatureTypeAutographCanModify: false,
              signatureTypeId: 3,
            })
          }
          break
      }
    }

    // If all signatureTypes have false value, then enable all checkboxes
    if (
      signatureTypeESign === false &&
      signatureTypeAdvance === false &&
      signatureTypeAutograph === false
    ) {
      this.setState({
        signatureTypeESignWillShow: true,
        signatureTypeAdvancedWillShow: true,
        signatureTypeAutographWillShow: true,
      })
    }

    /* === Validating Process Type Checkboxes === */
    /* 1.- Random || 2.- Sequential || 3.- Aprovation || 4.- AprovationSequential */
    let arrayProcessTypes = [
      { id: 1, active: processRandom },
      { id: 2, active: processSequential },
      { id: 3, active: processAprovation },
      { id: 4, active: processAprovationSequential },
    ]

    for (let i = 0; i < arrayProcessTypes.length; i++) {
      // eslint-disable-next-line default-case
      switch (arrayProcessTypes[i].id) {
        case 1:
          if (arrayProcessTypes[i].active === true) {
            this.setState({ processTypeRandomWillShow: true })
          }
          if (
            processRandom === true &&
            processSequential === false &&
            processAprovation === false &&
            processAprovationSequential === false
          ) {
            this.setState({
              processTypeRandomChecked: true,
              processTypeRandomCanModify: false,
              processTypeId: 1,
            })
          }
          break
        case 2:
          if (arrayProcessTypes[i].active === true) {
            this.setState({ processTypeSequentialWillShow: true })
          }
          if (
            processRandom === false &&
            processSequential === true &&
            processAprovation === false &&
            processAprovationSequential === false
          ) {
            this.setState({
              processTypeSequentialChecked: true,
              processTypeSequentialCanModify: false,
              processTypeId: 2,
            })
          }
          break
        case 3:
          if (arrayProcessTypes[i].active === true) {
            this.setState({ processTypeAprovationlWillShow: true })
          }
          if (
            processRandom === false &&
            processSequential === false &&
            processAprovation === true &&
            processAprovationSequential === false
          ) {
            this.setState({
              processTypeAprovationChecked: true,
              processTypeAprovationCanModify: false,
              processTypeId: 3,
            })
          }
          break
        case 4:
          if (arrayProcessTypes[i].active === true) {
            this.setState({ processTypeAprovationSequentialWillShow: true })
          }
          if (
            processRandom === false &&
            processSequential === false &&
            processAprovation === false &&
            processAprovationSequential === true
          ) {
            this.setState({
              processTypeAprovationSequentialChecked: true,
              processTypeAprovationSequentialCanModify: false,
              processTypeId: 4,
            })
          }
          break
      }
    }

    // If all processTypes have false value, then enable all checkboxes
    if (
      processRandom === false &&
      processSequential === false &&
      processAprovation === false &&
      processAprovationSequential === false
    ) {
      this.setState({
        processTypeRandomWillShow: true,
        processTypeSequentialWillShow: true,
        processTypeAprovationlWillShow: true,
        processTypeAprovationSequentialWillShow: true,
      })
    }

    let services = initialState['servicesService.getSignatureTypes']
    if (!services) {
      services = await this.serviceService.getServices(this.token)

      // Delete the service ID 3 to the list of services (BORRAR DESPUES)
      for (let i = 0; i < services.length; i++) {
        if (services[i].id === 3) services.splice(i, 1)
      }

      initialState['servicesService.getSignatureTypes'] = services
    }

    try {
      if (
        this.state.signatureByVolumeProfile.serviceConservationMessage ||
        this.state.signatureByVolumeProfile.serviceTimeStamp === true
      ) {
        this.setState({
          services: services.map((i) => ({ ...i, isActive: true })),
          loading: false,
        })
      } else {
        this.setState({
          services: services.map((i) => ({ ...i, isActive: false })),
          loading: false,
        })
      }
    } catch (error) {
      this.props.history.push('/signature-request-module')
      this.scrollWindow()
      return
    }
  }

  // Change checkbox of service Stamp Time
  onSelectServiceST = () => {
    if (this.state.serviceSTCanModify === false) return false

    const serviceAlreadyExist = this.state.servicesId.find(
      (item) => Number(item) === 1
    )
    if (!serviceAlreadyExist) {
      this.setState({
        serviceSTChecked: true,
        servicesId: this.state.servicesId.concat(1),
      })
    } else {
      let array = [...this.state.servicesId]
      let index = array.indexOf(1)

      if (index !== -1) {
        array.splice(index, 1)
        this.setState({
          serviceSTChecked: false,
          servicesId: array,
        })
      }
    }
  }

  // Change checkbox of service Conservation Message
  onSelectServiceCM = () => {
    if (this.state.serviceCMCanModify === false) return false

    const serviceAlreadyExist = this.state.servicesId.find(
      (item) => Number(item) === 2
    )
    if (!serviceAlreadyExist) {
      this.setState({
        serviceCMChecked: true,
        servicesId: this.state.servicesId.concat(2),
      })
    } else {
      let array = [...this.state.servicesId]
      let index = array.indexOf(2)

      if (index !== -1) {
        array.splice(index, 2)
        this.setState({
          serviceCMChecked: false,
          servicesId: array,
        })
      }
    }
  }

  // Change Checkbox of signatureType ESign
  onSelectESign = () => {
    if (this.state.signatureTypeESignCanModify === false) return false

    this.setState({
      signatureTypeESignChecked: true,
      signatureTypeAdvancedChecked: false,
      signatureTypeAutographChecked: false,
      signatureTypeId: 1,
      signatureTypeCheckThree: 'e.Firma',
    })
  }

  // Change Checkbox of signatureType Advanced
  onSelectAdvanced = () => {
    if (this.state.signatureTypeAdvancedCanModify === false) return false

    this.setState({
      signatureTypeESignChecked: false,
      signatureTypeAdvancedChecked: true,
      signatureTypeAutographChecked: false,
      signatureTypeId: 2,
      signatureTypeCheck: 'Firma Digital Avanzada',
    })
  }

  // Change Checkbox of signatureType Autograph
  onSelectAutograph = () => {
    if (this.state.signatureTypeAutographCanModify === false) return false

    this.setState({
      signatureTypeESignChecked: false,
      signatureTypeAdvancedChecked: false,
      signatureTypeAutographChecked: true,
      signatureTypeId: 3,
      signatureTypeCheckTwo: 'Firma Autógrafa Digital',
    })
  }

  // Change Checkbox of process random
  onSelectRandom = () => {
    if (this.state.processTypeRandomCanModify === false) return false

    this.setState({
      processTypeRandomChecked: true,
      processTypeSequentialChecked: false,
      processTypeAprovationChecked: false,
      processTypeAprovationSequentialChecked: false,
      processTypeId: 1,
      processTypeName: 'Aleatorio',
    })
  }

  // Change Checkbox of process sequential
  onSelectSequential = () => {
    if (this.state.processTypeSequentialCanModify === false) return false

    this.setState({
      processTypeRandomChecked: false,
      processTypeSequentialChecked: true,
      processTypeAprovationChecked: false,
      processTypeAprovationSequentialChecked: false,
      processTypeId: 2,
      processTypeName: 'Sequencial',
    })
  }

  // Change Checkbox of process aprovation
  onSelectAprovation = () => {
    if (this.state.processTypeAprovationCanModify === false) return false

    this.setState({
      processTypeRandomChecked: false,
      processTypeSequentialChecked: false,
      processTypeAprovationChecked: true,
      processTypeAprovationSequentialChecked: false,
      processTypeId: 3,
      processTypeName: 'Aprovación',
    })
  }

  // Change Checkbox of process aprovation sequential
  onSelectAprovationSequential = () => {
    if (this.state.processTypeAprovationSequentialCanModify === false)
      return false

    this.setState({
      processTypeRandomChecked: false,
      processTypeSequentialChecked: false,
      processTypeAprovationChecked: false,
      processTypeAprovationSequentialChecked: true,
      processTypeId: 4,
      processTypeName: 'Aprovación secuencial',
    })
  }

  onBackStep = () => {
    if (this.state.selectedStep === 0) {
      this.props.history.push('/signature-request-module')
    } else {
      this.setState({
        selectedStep: this.state.selectedStep - 1,
      })
    }

    return window.scroll(0, 0)
  }

  onNextStep = () => {
    this.setState({
      selectedStep: this.state.selectedStep + 1,
    })

    return window.scroll(0, 0)
  }

  onChangeComments = (e) => {
    this.setState({ comments: e.target.value }, () => {
      let commentsValid = this.validator.commentsValidator(this.state.comments)
      if (commentsValid && commentsValid !== '') {
        this.setState({ errorCurrentComments: true })
      } else {
        this.setState({ errorCurrentComments: false })
      }
    })
  }

  onSubmitDescriptions = (event) => {
    const { isValid, values } = event

    if (!isValid) {
      return
    }
    this.setState({
      requestName: values.name,
      description: values.description,
    })
    this.onNextStep()
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    })
  }

  toggleCompletedRequesting = (value) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false })
          this.props.history.push('/')
        }, 4000)
      }
    )
  }

  /**
   * @param {boolean} value
   * @param {string} message
   * @memberof SignRequestByVolumeAction
   */
  toggleErrorRequesting = (value = true, message = "") => {
    this.setState(
      {
        showErrorRequesting: value,
        message
      },
      () => {
        setTimeout(() => {
          this.setState({
            showErrorRequesting: false,
            message: ''
          })
        }, 4000)
      }
    )
  }

  handleSubmitConfirm = (event) => {
    event.preventDefault()
    this.confirm()
    this.setState({ disableSignerButton: true })
  }

  /**
   * @param {Array} csvJson
   * @param {string} textFileCsv
   * @memberof SignRequestByVolumeAction
   */
  onLoadCsv = async (csvJson, textFileCsv) => {
    const filesInCSV = csvJson.map(user => user.fileName)
    this.setState({ csvJson, csvJsonAsText: textFileCsv, filesInCSV })
  }

  onSendToSign = async () => {
    try {
      await this.toggleLoadingRequesting(true)

      let signRequestBodyByVolume = new FormData()

      let body = this.state.csvJson.map((register) => {
        let userTypeId = Number(process.env.REACT_APP_USER_TYPE_COLABORADOR)
        const signerIsCollaborator = this.state.collaboratorListAllow.find((collab) => { return collab.email === register.email })
        const signerIsInvite = this.state.inviteListAllow.find((invite) => { return invite.email === register.email })
        if (signerIsInvite) userTypeId = Number(process.env.REACT_APP_USER_TYPE_INVITADO)

        if (!signerIsCollaborator && !signerIsInvite) {
          const emailDomain = extractEmailDomain(register.email)
          const domainIsAllowed = this.state.domains.find((domain) => { return domain === emailDomain })
          if (!domainIsAllowed) userTypeId = Number(process.env.REACT_APP_USER_TYPE_INVITADO)
        }

        let signerTypeIdByRegister = {
          email: register.email,
          firstLastName: register.lastName,
          firstName: register.firstName,
          secondLastName: register.lastName,
          userTypeId,
        }

        let fileSelected = this.state.selectedFiles.find(file => file.name === register.fileName)
        let configFiles = [{
          name: fileSelected.name
        }]

        let signers = [
          {
            email: register.email,
            firstLastName:
              signerTypeIdByRegister.firstLastName !== ''
                ? signerTypeIdByRegister.firstLastName
                : register.lastName,
            firstName:
              signerTypeIdByRegister.firstName !== ''
                ? signerTypeIdByRegister.firstName
                : register.firstName,
            signerTypeId: signerTypeIdByRegister.userTypeId,
            sendDocument: false,
            eventId: 1,
            order: 0,
            proofOfLife: false,
            signerEvent: {
              signerEventTypeId: 1,
              eventId: 1,
            },
            coordinates: undefined,
          },
        ]

        let signData = {
          name: this.state.requestName,
          comments: this.state.comments ?? '',
          signtureRequestProfile: this.state.signtureRequestProfile,
          configFiles,
          signers,
        }

        return signData

        // return {
        //   name: this.state.requestName,
        //   description: this.state.description ??'',
        //   comments: this.state.comments ??'',
        //   eventId: '1',
        //   limitDate: this.state.limitDate,
        //   documentAccept: 'true',
        //   requireSignSupport:'',
        //   servicesId: this.state.servicesId,
        //   signatureTypeId: this.state.signatureTypeId,
        //   processTypeId: this.state.processTypeId,
        //   timezome: this.state.timezone,
        //   file: register.fileName,
        //   signers: [
        //     {
        //       id: '1',
        //       signerTypeId: signerTypeIdByRegister.userTypeId,
        //       order: 0,
        //       firstName:
        //         signerTypeIdByRegister.firstName !==''
        //           ? signerTypeIdByRegister.firstName
        //           : register.firstName,
        //       firstLastName:
        //         signerTypeIdByRegister.firstLastName !==''
        //           ? signerTypeIdByRegister.firstLastName
        //           : register.lastName,
        //       signerEvent: {
        //         signerEventTypeId: 1,
        //         eventId: 1,
        //       },
        //       email: register.email,
        //     },
        //   ],
        // }
      })

      let dataClassifier = {
        companyId: NIL_UUID,
        categoryId: 0,
        subCategoryId: 0,
        typeDocument: {},
        pathBreadcrumb: ''
      }

      signRequestBodyByVolume.append('limitDate', this.state.limitDate)
      signRequestBodyByVolume.append('documentAccept', 'true')
      signRequestBodyByVolume.append('exportPdf', false)
      signRequestBodyByVolume.append('servicesId', JSON.stringify(this.state.servicesId))
      signRequestBodyByVolume.append('signatureTypeId', this.state.signatureTypeId)
      signRequestBodyByVolume.append('processTypeId', this.state.processTypeId)
      signRequestBodyByVolume.append('timezone', this.state.timezone)
      signRequestBodyByVolume.append('dataClassifier', JSON.stringify(dataClassifier))
      signRequestBodyByVolume.append('signData', JSON.stringify(body))
      signRequestBodyByVolume.append('documentManageId', +process.env.REACT_APP_DOCUMENT_MANAGE_ID_VOLUMEN)
      // signRequestBodyByVolume.append('signRequestList', JSON.stringify(body))

      this.state.selectedFiles.forEach((file) => {
        return signRequestBodyByVolume.append('files', file)
      })

      const res = await this.signatureRequestService.createSignRequest(signRequestBodyByVolume, this.token)
      if (res && res.statusCode === 200) {
        await this.toggleLoadingRequesting(false)
        await this.toggleCompletedRequesting(true)
        return true
      } else if (res && Number(res.statusCode) === 409) {
        await this.toggleLoadingRequesting(false)
        this.setState({
          message: `${this.props.t('signatureRequestProfile.errors.signers.inactive')}`
        })
        await this.toggleErrorRequesting(true)
        return false
      } else {
        await this.toggleLoadingRequesting(false)
        await this.toggleErrorRequesting(true)
      }
    } catch (error) {
      await this.toggleLoadingRequesting(false)
      await this.toggleErrorRequesting(true)
      return false
    }
  }

  setSignatureTypes = (val) => {
    this.setState({
      signatureTypesInputValue: val,
      errorSignatureTypeId: false,
    })
  }

  setProcessTypes = (val) => {
    this.setState({
      processTypesInputValue: val,
      errorProcessTypeId: false,
    })
  }

  setServices = (services) => {
    this.setState({ services })
  }

  handleFiles = async (files) => {
    const correctFiles = []
    Object.values(files).map((file) => {
      const fileExistCsv = this.state.csvJson.find(
        (csv) => csv.fileName === file.name
      )
        ? true
        : false

      const fileExistInSelectedFiles = this.state.selectedFiles.find(
        (fileInState) => fileInState.name === file.name
      )
        ? true
        : false

      if (fileExistCsv && !fileExistInSelectedFiles) {
        correctFiles.push(file)
      } else {
        this.setState({
          errorFiles: true,
        })
        return false
      }
    })
    this.setState({
      selectedFiles: [...this.state.selectedFiles, ...correctFiles],
    })
  }

  handleDeleteRecord = (fileNameToDelete) => {
    const newCsvArray = this.state.csvJson.filter(
      (csv) => csv.fileName !== fileNameToDelete
    )

    const newFilesArray = this.state.selectedFiles.filter(
      (file) => file.name !== fileNameToDelete
    )
    this.setState({
      csvJson: newCsvArray,
      selectedFiles: newFilesArray,
    })
  }

  handleEditRegister = (currentData, newData) => {
    this.setState((prevState) => ({
      csvJson: prevState.csvJson.map((registry) =>
        registry.fileName === currentData.fileName
          ? { ...registry, ...newData }
          : registry
      ),
    }))
  }

  handleLimitDate = (newLimitDate) => {
    this.setState({
      limitDate: newLimitDate,
    })
  }

  handleAdditionalServices = (date) => {
    this.setState({
      limitDate: date,
    })

    this.onNextStep()
  }

  onValidateProfileData = () => {
    const {
      requestName,
      errorCurrentNameSignature,
      errorCurrentDescription,
      errorCurrentComments,
    } = this.state
    let [emptyName] = [false]

    if (!requestName || requestName.trim() === '' || requestName.length <= 0) {
      emptyName = true
      this.setState({
        errorCurrentNameSignature: true,
        errorMessageCurrentNameSignature: this.props.t(
          'signatureRequestProfileData.nameSignature'
        ),
      })
    }

    if (emptyName === true) return false
    if (
      errorCurrentNameSignature === true ||
      errorCurrentDescription === true ||
      errorCurrentComments === true
    )
      return false

    this.setState({
      errorCurrentNameSignature: false,
      errorCurrentDescription: false,
      errorCurrentComments: false,
      errorMessageCurrentNameSignature: '',
      errorMessageCurrentDescription: '',
      errorMessageCurrentComments: '',
    })
    this.onNextStep()
  }

  onChangeNameSignature = (e) => {
    this.setState({ requestName: e.target.value })
    let nameSignatureValid = this.validator.nameValidator(e.target.value)
    let errorCurrentNameSignature =
      nameSignatureValid && nameSignatureValid !== '' ? true : false
    let errorMessageCurrentNameSignature =
      errorCurrentNameSignature === true ? nameSignatureValid : ''
    this.setState({
      errorCurrentNameSignature,
      errorMessageCurrentNameSignature,
    })
  }

  onChangeSummaryDescription = (e) => {
    this.setState({ description: e.target.value })
    let descriptionValid = this.validator.descriptionValidator(e.target.value)
    let errorCurrentDescription =
      descriptionValid && descriptionValid !== '' ? true : false
    let errorMessageCurrentDescription =
      errorCurrentDescription === true ? descriptionValid : ''
    this.setState({ errorCurrentDescription, errorMessageCurrentDescription })
  }

  onValidateSigners = async () => {
    let allUsersAactive = true
    this.state.csvJson.forEach(element => {
      let userIsInactive = this.state.usersCollaborator.find(user => { return user.email === element.email && !user.status })
      if (userIsInactive) allUsersAactive = false
    })

    if (allUsersAactive) {
      this.onNextStep()
    } else {
      this.setState({
        message: `${this.props.t('signatureRequestProfile.errors.signers.inactive')}`
      })
      await this.toggleErrorRequesting(true)
      return false
    }
  }


  onChangeComments = (e) => {
    this.setState({ comments: e.target.value })
    // let commentsValid = this.validator.nameValidator(e.target.value)
    // let errorCurrentComments =
    //   commentsValid && commentsValid !=='' ? true : false
    // let errorMessageCurrentComments =
    //   errorCurrentComments === true ? commentsValid :''
    // this.setState({ errorCurrentComments, errorMessageCurrentComments })
  }

  steps = [
    {
      icon: SignRequestByVolumeStepOneIcon,
      title: this.props.t('signRequestByVolume.title.firstStep'),
      next: this.props.t('signRequestByVolume.continue'),
      back: this.props.t('signRequestByVolume.exit'),
      instruction: this.props.t('signRequestByVolume.instructions1'),
    },
    {
      icon: SignRequestByVolumeStepTwoIcon,
      title: this.props.t('signRequestByVolume.title.secondStep'),
      next: this.props.t('signRequestByVolume.continue'),
      back: this.props.t('signRequestByVolume.back'),
      load: this.props.t('signRequestByVolume.loadCSV'),
      instruction: this.props.t('signRequestByVolume.instructions2'),
    },
    {
      icon: SignRequestByVolumeStepThreeIcon,
      title: this.props.t('signRequestByVolume.title.thirdStep'),
      next: this.props.t('signRequestByVolume.continue'),
      back: this.props.t('signRequestByVolume.back'),
      load: this.props.t('signRequestByVolume.loadFiles'),
      instruction: this.props.t('signRequestByVolume.instructions3'),
    },
    {
      icon: SignRequestByVolumeStepFourIcon,
      title: this.props.t('signRequestByVolume.title.fourthStep'),
      next: this.props.t('signRequestByVolume.continue'),
      back: this.props.t('signRequestByVolume.back'),
      instruction: this.props.t('signRequestByVolume.instructions4'),
    },
    {
      icon: SignRequestByVolumeStepFiveIcon,
      title: this.props.t('signRequestByVolume.title.fifthStep'),
      send: this.props.t('signRequestByVolume.sendToSign'),
      back: this.props.t('signRequestByVolume.back'),
      instruction: '',
    },
  ]

  stepMetadata = [
    {
      number: 0,
      component: SignRequestByVolumeDescriptionView,
      back: this.onBackStep,
      next: this.onNextStep,
    },
    {
      number: 1,
      component: SignRequestByVolumeUploadFilesView,
      back: this.onBackStep,
      next: this.onNextStep,
      load: this.onLoadCsv,
    },
    {
      number: 2,
      component: SignRequestByVolumeSignersListView,
      back: this.onBackStep,
      next: this.onValidateSigners,
    },
    {
      number: 3,
      component: SignRequestByVolumeAdditionalServicesView,
      back: this.onBackStep,
      next: this.onNextStep,
    },
    {
      number: 4,
      component: SignRequestByVolumeResume,
      back: this.onBackStep,
      send: this.onSendToSign,
    },
  ]

  render() {
    return (
      <div className='standard-wrapper'>
        {this.state.loading
          ? <SimpleLoading />
          :
          <SignRequestByVolumeView
            {...this.state}
            {...this.props}
            user={this.user}
            steps={this.steps}
            stepMetadata={this.stepMetadata}
            validateInput={ValidateInputPure}
            onChangeComments={this.onChangeComments}
            onSubmit={this.onSubmitDescriptions}
            validator={this.validator}
            handleFiles={this.handleFiles}
            handleDeleteRecord={this.handleDeleteRecord}
            handleEditRegister={this.handleEditRegister}
            setSignatureTypes={this.setSignatureTypes}
            setProcessTypes={this.setProcessTypes}
            handleAdditionalServices={this.handleAdditionalServices}
            setServices={this.setServices}
            toggleLoadingRequesting={this.toggleLoadingRequesting}
            toggleCompletedRequesting={this.toggleCompletedRequesting}
            toggleErrorRequesting={this.toggleErrorRequesting}
            onSelectAprovationSequential={this.onSelectAprovationSequential}
            onSelectAprovation={this.onSelectAprovation}
            onSelectSequential={this.onSelectSequential}
            onSelectRandom={this.onSelectRandom}
            onSelectAutograph={this.onSelectAutograph}
            onSelectAdvanced={this.onSelectAdvanced}
            onSelectESign={this.onSelectESign}
            onSelectServiceCM={this.onSelectServiceCM}
            onSelectServiceST={this.onSelectServiceST}
            onValidateProfileData={this.onValidateProfileData}
            onChangeNameSignature={this.onChangeNameSignature}
            onChangeSummaryDescription={this.onChangeSummaryDescription}
            handleLimitDate={this.handleLimitDate}
          />
        }
      </div>
    )
  }
}

export default withTranslation()(SignRequestByVolumeAction)